import { render, staticRenderFns } from "./Milestone.vue?vue&type=template&id=01c2c528&scoped=true&"
import script from "./Milestone.vue?vue&type=script&lang=js&"
export * from "./Milestone.vue?vue&type=script&lang=js&"
import style0 from "./Milestone.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Milestone.vue?vue&type=style&index=1&id=01c2c528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2c528",
  null
  
)

export default component.exports